import { store } from '@betacrew/jars-flux'
import { put, all, takeLatest, takeEvery, call, fork } from 'redux-saga/effects';
import { componentKey, setDefaultReporingCompanyFieldsArr, setErrorInFormFieldsOrFormData, setFormRecordId, setGoToManageBoiScreen, setGridSelectedRecipients, setIsAddNewBenefiarySelected, setIsBeneficialSelectAllSelected, setLoadDependentFieldsArr, setLoadingState, setPayerListPaginationState, setPayersList, setRecipientList, setRecipientListPaginationState, setReloadBeneficiaryList, setReloadPayersList, setReportingCompanyDetailId, setReportingCompanyLoadingState, setReportingCompanyScreenNxtBtnClicked, setReviewStepSelectedBeneficialsData, setSelectedBeneficialDetailIds, setSelectedCompanyApplicantIds, setStepperRefreshStep, setUserInteractionPopupWResponseObj, updateBoiFormFields, updateFormsPreLoadedData, updateUserInteractionPopupWResponseObj } from './FileBoiSlice';
import BoiDataService from '../../../../services/BoiDataService';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import PayerDataService from '../../../../services/PayerDataService';
import General from '../../../../libs/utility/General';
import { BOI_FORM_STEPS, COMPANY_APPLICANT_ID_FIELD_NAME, FILE_BOI_LOADING_STATES, IS_BENEFICIAL_SELECT_ALL_SELECTED, MANAGE_BOI_LOADING_STATES, PAYER_DETAIL_ID_FIELD_NAME } from '../constants';
import RecipientDataService from '../../../../services/RecipientDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import FormsDataService from '../../../../services/FormsDataService';
import { FIELD_TYPES } from '../../../../libs/formdatavalidator/constants';
import Forms from '../../../../libs/utility/formsutility/Forms';

export const { getPaginatedPayersList, getPaginatedRecipientsList, getBoiFormFields, saveBoiForm, saveCompanyApplicants, getBeneficiaryOwners, requestBeneficiaryOwnerEmail, onDependentFieldChangeGetValues, saveReportingCompany, getReportingCompanyDetails, getFormData, deleteBeneficiary, deleteReportingCompany, getCompanyApplicants, getReviewData } = {
	getPaginatedPayersList: (payload) => {
		return {
			type: "FILE_BOI/GET_PAGINATED_PAYERS",
			payload: payload
		}
	},
	getPaginatedRecipientsList: (payload) => {
		return {
			type: "FILE_BOI/GET_PAGINATED_RECIPIENTS",
			payload: payload
		}
	},
    getBoiFormFields: (payload) => {
		return {
			type: "FILE_BOI/GET_FORM_FIELDS",
			payload: payload
		}
	},
    saveBoiForm: (payload) => {
		return {
			type: "FILE_BOI/SAVE",
			payload: payload
		}
	},
    saveCompanyApplicants: (payload) => {
		return {
			type: "FILE_BOI/SAVE_COMPANY_APPLICANTS",
			payload: payload
		}
	},
    getBeneficiaryOwners: (payload) => {
        return {
            type: "FILE_BOI/GET_BENEFICIARIES",
            payload
        }
    },
    requestBeneficiaryOwnerEmail: (payload) => {
        return {
            type: "FILE_BOI/GET_BENEFICIARY_EMAIL_REQUEST",
            payload
        }
    },
    onDependentFieldChangeGetValues: (payload) => {
        return {
            type: "FILE_BOI/CALCULATE_INFERRED_VALUES",
            payload
        }
    },
    saveReportingCompany: (payload) => {
        return {
            type: "FILE_BOI/SAVE_REPORTING_COMPANY",
            payload
        }
    },
    getReportingCompanyDetails: (payload) => {
        return {
            type: "FILE_BOI/GET_REPORTING_COMPANY_DETAILS",
            payload
        }
    },
    getFormData: (payload) => {
        return {
            type: "FILE_BOI/GET_FORM_DATA",
            payload
        }
    },
    deleteBeneficiary: (payload) => {
        return {
            type: "FILE_BOI/DELETE_BENEFICIARY",
            payload
        }
    },
    deleteReportingCompany: (payload) => {
        return {
            type: "FILE_BOI/DELETE_REPORTING_COMPANY",
            payload
        }
    },
    getCompanyApplicants: (payload) => {
        return {
            type: "FILE_BOI/GET_COMPANY_APPLICANTS",
            payload
        }
    },
    getReviewData: (payload) => {
        return {
            type: "FILE_BOI/GET_REVIEW_DATA",
            payload
        }
    },
}

function* getPaginatedPayersListAsync(action){
    try {
        yield put(setReportingCompanyLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_LOADING }))

        const { PageNumber, PageSize, FilterText, IsDesc, IdNumber, formName } = action.payload;

        const params = {
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IdNumber: IdNumber || "",
            IsDesc: IsDesc || false,
            formName: formName || "",
        }

        const response = yield PayerDataService.getPaginatedPayersList(params);

        const { Message, Status } = response?.data;
        const Data  = General.extractDataFromResponseData(response.data)

        if (Status && Data) {
            yield put(setPayersList(Data));

            yield put(setPayerListPaginationState({ totalRecords: General.extractPaginationTotalFromResponse(response.data) }))

        } else {
            yield put(addNotifications({ heading: "Error",  message: Message}));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setReportingCompanyLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_READY }))
    }
}

function* getPaginatedRecipientsListAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_LOADING }))

        const { PageNumber, PageSize, FilterText, PayerId } = action.payload;

        const params = {
            PayerId: PayerId,
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IsDesc: false,
            IdNumber: "",
            IsActive: "",
            IsTinRequested: "",
            IsW8request: "",
            IsW9Request: "",
            TinStartDate: "",
            TinEndDate: "",
            Email: "",
            TINStatus: "",
            IsUSPSValid: false,
        }

        const response = yield RecipientDataService.getPaginatedRecipientList(params);

        const { Message, Status } = response?.data;
        const Data =  General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setRecipientList(Data));

            yield put(setRecipientListPaginationState({ ...action.payload, totalRecipients: General.extractPaginationTotalFromResponse(response.data) }))


        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_READY }))
    }
}

function* getBeneficiaryOwnersAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_LOADING }))

        const { PageNumber, PageSize, FilterText, PayerId, isBeneficialSelectAllSelected } = action.payload;

        const params = {
            payerId: PayerId,
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IsDesc: false,
            IdNumber: "",
            IsActive: "",
            IsTinRequested: "",
            IsW8request: "",
            IsW9Request: "",
            TinStartDate: "",
            TinEndDate: "",
            Email: "",
            TINStatus: "",
            IsUSPSValid: false,
        }

        const response = yield BoiDataService.getBeneficiaryOwners(params);

        const { Message, Status } = response?.data;
        const Data =  General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setRecipientList(Data));
            yield put(setRecipientListPaginationState({ ...action.payload, totalRecords: General.extractPaginationTotalFromResponse(response.data) }))
            if(isBeneficialSelectAllSelected){
                yield put(setGridSelectedRecipients(Data));
            }


        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_READY }))
    }
}



function* getBoiFormFieldsAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.FILE_BOI_MAIN_LOADING }))
        const {formRecordId = 0} = action.payload;

        let reportingCompanyResp = null;
        let filingInfoResp = null;
        let companyApplicationResp = null;
        let benificialOwnerResp = null;
        let formDataResponse = null;
        let submitResp = null;

        reportingCompanyResp = yield call(BoiDataService.getBoiFormFields, BOI_FORM_STEPS.REPORTING_COMPANY, formRecordId);
        filingInfoResp = yield call(BoiDataService.getBoiFormFields, BOI_FORM_STEPS.FILING_INFO, formRecordId);
        companyApplicationResp = yield call(BoiDataService.getBoiFormFields, BOI_FORM_STEPS.COMPANY_APPLICATION, formRecordId);
        benificialOwnerResp = yield call(BoiDataService.getBoiFormFields, BOI_FORM_STEPS.BENEFICIAL_OWNER, formRecordId);
        submitResp = yield call(BoiDataService.getBoiFormFields, BOI_FORM_STEPS.SUBMIT, formRecordId);
        
        if(formRecordId){
            formDataResponse = yield call(BoiDataService.getFormData, {formRecordId: formRecordId});
        }

        let formFieldsObj = {};
        let isError = false;
        if(reportingCompanyResp?.data?.Status === 1 && reportingCompanyResp?.data?.Data){
            formFieldsObj = {
                ...formFieldsObj,
                [BOI_FORM_STEPS.REPORTING_COMPANY]: reportingCompanyResp?.data?.Data
            }
            yield put(setDefaultReporingCompanyFieldsArr(reportingCompanyResp?.data?.Data))
        }else{
            isError = true;
            yield put(addNotifications({
                heading: "Error",
                message: reportingCompanyResp?.data?.Message
            }));
        }

        if(filingInfoResp?.data?.Status === 1 && filingInfoResp?.data?.Data){
            formFieldsObj = {
                ...formFieldsObj,
                [BOI_FORM_STEPS.FILING_INFO]: filingInfoResp?.data?.Data
            }
        }else{
            isError = true;
            yield put(addNotifications({
                heading: "Error",
                message: filingInfoResp?.data?.Message
            }));
        }
        if(companyApplicationResp?.data?.Status === 1 && companyApplicationResp?.data?.Data){
            formFieldsObj = {
                ...formFieldsObj,
                [BOI_FORM_STEPS.COMPANY_APPLICATION]: companyApplicationResp?.data?.Data
            }
        }else{
            isError = true;
            yield put(addNotifications({
                heading: "Error",
                message: companyApplicationResp?.data?.Message
            }));
        }
        if(benificialOwnerResp?.data?.Status === 1 && benificialOwnerResp?.data?.Data){
            formFieldsObj = {
                ...formFieldsObj,
                [BOI_FORM_STEPS.BENEFICIAL_OWNER]: benificialOwnerResp?.data?.Data
            }
        }else{
            isError = true;
            yield put(addNotifications({
                heading: "Error",
                message: benificialOwnerResp?.data?.Message
            }));
        }
        if(submitResp?.data?.Status === 1 && submitResp?.data?.Data){
            formFieldsObj = {
                ...formFieldsObj,
                [BOI_FORM_STEPS.SUBMIT]: submitResp?.data?.Data
            }
        }else{
            isError = true;
            yield put(addNotifications({
                heading: "Error",
                message: submitResp?.data?.Message
            }));
        }

        if(formRecordId){
            if(formDataResponse?.data?.Status){
                const returnedFormRecordIdData = formDataResponse?.data?.Data;
                let tempFieldsObj = {};
                for (const prop in formFieldsObj) {
                    if (formFieldsObj.hasOwnProperty(prop)) {
                        /* formFieldsObj[prop].forEach(obj => {
                            if (returnedFormRecordIdData.hasOwnProperty(obj?.Name)) {
                                obj.inputValue = returnedFormRecordIdData[obj?.Name];
                            }
                        }); */
                        const modifiedObjectsArr = formFieldsObj[prop].map(obj => {
                            if (returnedFormRecordIdData.hasOwnProperty(obj?.Name)) {
                                return { ...obj, inputValue: returnedFormRecordIdData[obj?.Name] };
                            }
                            return obj;
                        });
                        tempFieldsObj = {
                            ...tempFieldsObj,
                            [prop]: modifiedObjectsArr
                        }
                    }
                }
                if(returnedFormRecordIdData.hasOwnProperty("PayerDetailId")){
                    yield put(setReportingCompanyDetailId(returnedFormRecordIdData.PayerDetailId))
                }
                if(returnedFormRecordIdData.hasOwnProperty("BeneficialOwnerDetailsId")){
                    yield put(setSelectedBeneficialDetailIds(returnedFormRecordIdData.BeneficialOwnerDetailsId))
                }
                if(returnedFormRecordIdData.hasOwnProperty(COMPANY_APPLICANT_ID_FIELD_NAME)){
                    yield put(setSelectedCompanyApplicantIds(returnedFormRecordIdData[COMPANY_APPLICANT_ID_FIELD_NAME]))
                }
                if(returnedFormRecordIdData.hasOwnProperty(IS_BENEFICIAL_SELECT_ALL_SELECTED)){
                    yield put(setIsBeneficialSelectAllSelected(returnedFormRecordIdData[IS_BENEFICIAL_SELECT_ALL_SELECTED]))
                }
                formFieldsObj = tempFieldsObj;
                yield put(setFormRecordId(formRecordId))
                yield put(setReportingCompanyScreenNxtBtnClicked(true));
            }else{
                isError = true;
                yield put(setErrorInFormFieldsOrFormData(true));
                yield put(addNotifications({
                    heading: "Error",
                    message: formDataResponse?.data?.Message,
                }));
            }
        }
        
        if(!isError){
            yield put(updateBoiFormFields(formFieldsObj))
            yield put(setLoadDependentFieldsArr(true))
        }else{
            yield put(addNotifications({
                heading: "Error",
                message: "Facing some error",
            }));
        }
    }catch(error){
        console.log("error", error)
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.FILE_BOI_MAIN_READY }))
    }
}

function* onDependentFieldChangeGetValuesAsync(action){
    try {
        const {formId, year, fieldId, allFields, targetElement = null} = action.payload;
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.CALCULATE_INFERRED_LOADING }));

        const updatedAllFields = Forms.stringifyFormFields(FIELD_TYPES.FILE_UPLOAD, allFields)
        
        const response = yield BoiDataService.onDependentFieldChangeGetValues({formId, year, fieldId, allFields: updatedAllFields});
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                if(response?.data?.Data?.interaction){
                    let updatedInteractionObj = response?.data?.Data?.interaction;
                    if(updatedInteractionObj?.negativeResponse){
                        let parsedNegativeResponseFieldsArr = Forms.deStringifyFormFields(FIELD_TYPES.FILE_UPLOAD, updatedInteractionObj?.negativeResponse ?? [])
                        updatedInteractionObj = {
                            ...updatedInteractionObj,
                            negativeResponse: parsedNegativeResponseFieldsArr
                        }
                    }
                    if(updatedInteractionObj?.positiveResponse){
                        let parsedPositiveResponseFieldsArr = Forms.deStringifyFormFields(FIELD_TYPES.FILE_UPLOAD, updatedInteractionObj?.positiveResponse ?? [])
                        updatedInteractionObj = {
                            ...updatedInteractionObj,
                            positiveResponse: parsedPositiveResponseFieldsArr
                        }
                    }
                    yield put(setUserInteractionPopupWResponseObj({formType: formId, ...updatedInteractionObj}))
                }
                const responseDataArray = response?.data?.Data?.allFields ?? [];
                let updatedAllFieldsFromResponse = Forms.deStringifyFormFields(FIELD_TYPES.FILE_UPLOAD, responseDataArray ?? [])
                
                yield put(updateBoiFormFields({[formId]: updatedAllFieldsFromResponse}));
                
                if(response?.data?.Data?.PreLoadedData){
                    yield put(updateFormsPreLoadedData({
                        ...response?.data?.Data?.PreLoadedData,
                    }));
                }
            }
        }
        /* if(targetElement){
            yield put(setElementToBeFocused(targetElement))
        } else {
            yield put(setElementToBeFocused(fieldId))
        } */
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.CALCULATE_INFERRED_READY }))
    }
}

function* saveBoiFormAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.SAVE_STEP_LOADING }))
        const {formData, currentStep, nextRefreshStepIndex} = action.payload;
        const response = yield BoiDataService.saveBoiForm(formData);
		if (response?.data?.Status && response.data.Status == 1) {
            yield put(setFormRecordId(response?.data?.Data ?? 0))
            if(currentStep !== BOI_FORM_STEPS.SUBMIT){
                yield put(setStepperRefreshStep(nextRefreshStepIndex))
            }else{
                yield put(setGoToManageBoiScreen(true))
                yield put(addNotifications({
                    heading: "Success",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.SUCCESS,
                }));
            }
		}else{
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message
            }));
        }
    }catch(error){
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.SAVE_STEP_READY }))
    }
}

function* saveCompanyApplicantsAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.SAVE_STEP_LOADING }))
        const {formData, nextRefreshStepIndex, boiFormFields} = action.payload;
        const response = yield BoiDataService.saveCompanyApplicants(formData);
		if (response?.data?.Status && response.data.Status == 1) {
            if(response?.data?.Data){
                let updatedFields = boiFormFields[BOI_FORM_STEPS.COMPANY_APPLICATION].map(item => {
                    if(item?.Name === COMPANY_APPLICANT_ID_FIELD_NAME){
                        return {
                            ...item,
                            inputValue: response?.data?.Data,
                        }
                    }else{
                        return item
                    }
                })
                yield put(updateBoiFormFields({
                    [BOI_FORM_STEPS.COMPANY_APPLICATION]: updatedFields,
                }))

                yield put(setSelectedCompanyApplicantIds(response?.data?.Data));
            }
            yield put(setStepperRefreshStep(nextRefreshStepIndex))
		}else{
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message
            }));
        }
    }catch(error){
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.SAVE_STEP_READY }))
    }
}

function* saveReportingCompanyAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.SAVE_STEP_LOADING }))
        const {formData, currentStep, nextRefreshStepIndex} = action.payload;
        const response = yield BoiDataService.saveReportingCompany(formData);
		if (response?.data?.Status && response.data.Status == 1) {
            yield put(setReportingCompanyDetailId(response?.data?.Data ?? 0))
            yield put(setStepperRefreshStep(nextRefreshStepIndex))
		}else{
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message
            }));
        }
    }catch(error){
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.SAVE_STEP_READY }))
    }
}

function* getReportingCompanyDetailsAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_DETAILS_LOADING }))
        const {reportingCompanyDetailId, boiFormFields} = action.payload;
        const params = {
            reportingCompanyDetailId: reportingCompanyDetailId
        }
        const response = yield BoiDataService.getReportingCompanyDetails(params);

		if (response?.data?.Status && response.data.Status == 1) {
            if(response?.data?.Data){
                if(Array.isArray(boiFormFields[BOI_FORM_STEPS.REPORTING_COMPANY])){
                    const updatedFields = boiFormFields[BOI_FORM_STEPS.REPORTING_COMPANY].map(item => {
                        return {
                            ...item,
                            inputValue: response?.data?.Data[item?.Name] ?? (item?.inputValue ?? "")
                        }
                    })

                    yield put(updateBoiFormFields({
                        [BOI_FORM_STEPS.REPORTING_COMPANY]: updatedFields
                    }))
                    yield call(onDependentFieldChangeGetValuesAsync, {payload: {
                        formId: BOI_FORM_STEPS.REPORTING_COMPANY ?? null,
                        year: "",
                        fieldId: PAYER_DETAIL_ID_FIELD_NAME,
                        allFields: updatedFields,
                    }})
                    yield put(setIsAddNewBenefiarySelected(true))
                    yield put(setReportingCompanyDetailId(reportingCompanyDetailId))
                    yield put(setReportingCompanyScreenNxtBtnClicked(true));

                }
            }
		}else{
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message
            }));
        }
    }catch(error){
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_DETAILS_READY }))
    }
}

function* requestBeneficiaryOwnerEmailAsync(action) {

    try {
        
        const { BeneficialOwnerDetailId } = action.payload
        yield put(setLoadingState({ state: `${FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_REQUEST_EMAIL_LOADING}-${BeneficialOwnerDetailId}` }))

        const params = {
            BeneficialOwnerDetailId: BeneficialOwnerDetailId || 0,
        }

        const response = yield BoiDataService.requestBeneficiaryOwnerEmail(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setReloadBeneficiaryList(true));            
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));            
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_REQUEST_EMAIL_READY }))
    }

}

function* getFormDataAsync(action){
    try {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.FILE_BOI_MAIN_LOADING }))
        const { formName, formYear, formRecordId = 0} = action.payload;
        const response = yield FormsDataService.getFormData(formName, formYear, formRecordId);
        if(response){
            if(response?.data?.Status === 1){
                const returnedFormData = response?.data?.Data ?? {};
                yield put(updateFormsPreLoadedData({
                    ...returnedFormData
                }));
                yield call(getBoiFormFieldsAsync, {payload: {formRecordId: formRecordId}});
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.FILE_BOI_MAIN_READY }))
    }
}

function* deleteBeneficiaryAsync(action) {

    try {
        const { beneficialOwnerDetailId } = action.payload
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_LOADING }))

        const response = yield BoiDataService.deleteBeneficiary({beneficialOwnerDetailId: beneficialOwnerDetailId});

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setReloadBeneficiaryList(true));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_READY }))
    }

}

function* deleteReportingCompanyAsync(action) {

    try {
        const { PayerDetailId } = action.payload
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_LOADING }))

        const response = yield BoiDataService.deleteReportingCompany({PayerDetailId: PayerDetailId});

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setReloadPayersList(true));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_READY }))
    }

}
function* getCompanyApplicantsAsync(action) {

    try {
        const { PayerDetailId, selectedCompanyApplicantIds = "" } = action.payload
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_LOADING }))

        const response = yield BoiDataService.getCompanyApplicants({payerDetailId: PayerDetailId});

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(Data){
                if(Array.isArray(Data) && Data.length > 0){
                    General.addOptionAndValueKeys(Data, "LastName", "CompanyApplicantId");
                    let updatedCompanyApplicantList = Data;
                    var inputValueArray = selectedCompanyApplicantIds.split(',');
                    if(inputValueArray.length > 0 && inputValueArray[0] !== ""){
                        updatedCompanyApplicantList = Data.map(function(option) {
                            if (inputValueArray.includes(option[COMPANY_APPLICANT_ID_FIELD_NAME])) {
                                return { ...option, checked: true };
                            }
                            return option;
                        });
                    }
                    yield put(updateFormsPreLoadedData({CompanyApplicantList: updatedCompanyApplicantList}))
                }else{
                    yield put(updateFormsPreLoadedData({CompanyApplicantList: []}))
                }
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_READY }))
    }

}

function* getReviewDataAsync(action) {

    try {
        const { FormRecordId, BeneficialOwnerDetailId = "", isBeneficialSelectAllSelected } = action.payload
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.GET_REVIEW_DETAILS_LOADING }))

        const response = yield BoiDataService.getReviewData({FormRecordId: FormRecordId, BeneficialOwnerDetailId: BeneficialOwnerDetailId, isBeneficialSelectAllSelected: isBeneficialSelectAllSelected});

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(Data && Array.isArray(Data)){
                yield put(setReviewStepSelectedBeneficialsData(Data))
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_BOI_LOADING_STATES.GET_REVIEW_DETAILS_READY }))
    }

}

function* rootSaga() {
	yield all([
		takeLatest(getPaginatedPayersList().type, getPaginatedPayersListAsync),
		takeLatest(getPaginatedRecipientsList().type, getPaginatedRecipientsListAsync),
		takeEvery(getBoiFormFields().type, getBoiFormFieldsAsync),
		takeLatest(saveBoiForm().type, saveBoiFormAsync),
		takeLatest(saveCompanyApplicants().type, saveCompanyApplicantsAsync),
		takeLatest(getBeneficiaryOwners().type, getBeneficiaryOwnersAsync),
		takeLatest(requestBeneficiaryOwnerEmail().type, requestBeneficiaryOwnerEmailAsync),
		takeLatest(onDependentFieldChangeGetValues().type, onDependentFieldChangeGetValuesAsync),
		takeLatest(saveReportingCompany().type, saveReportingCompanyAsync),
		takeLatest(getReportingCompanyDetails().type, getReportingCompanyDetailsAsync),
		takeLatest(getFormData().type, getFormDataAsync),
		takeLatest(deleteBeneficiary().type, deleteBeneficiaryAsync),
		takeLatest(deleteReportingCompany().type, deleteReportingCompanyAsync),
		takeLatest(getCompanyApplicants().type, getCompanyApplicantsAsync),
		takeLatest(getReviewData().type, getReviewDataAsync),
	]);
}

store.sagaManager.addSaga(componentKey, rootSaga);